import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {PointGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {AttributeSetLambdaParameters} from "#template/nodes/geometry-graph/attribute-set/attribute-set-lambda/geometry-attribute-set-lambda-node"
import {
    GeometryAttributeSetLambdaNode,
    attributeSetLambdaParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/attribute-set-lambda/geometry-attribute-set-lambda-node"

export type PointGeometryAttributeSetLambdaParameters = AttributeSetLambdaParameters<0>

const definition: TemplateNodeDefinition<PointGeometryAttributeSetLambdaParameters> = {
    nodeClass: "PointGeometryAttributeSetLambda",
    validation: {
        parameters: attributeSetLambdaParametersSchema<0>(),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryAttributeSetLambda
    extends GeometryAttributeSetLambdaNode<0, PointGeometryAttributeSetLambdaParameters>
    implements PointGeometryAttributeSetLikeNode
{
    get [pointGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
